module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }